import { render } from "./AccountantDashboard.vue?vue&type=template&id=ddb840d2&scoped=true"
import script from "./AccountantDashboard.vue?vue&type=script&lang=js"
export * from "./AccountantDashboard.vue?vue&type=script&lang=js"

import "./AccountantDashboard.vue?vue&type=style&index=0&id=ddb840d2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb840d2"]])

export default __exports__